/**
 * Created by aaron on 2018/5/15.
 */
import { observable } from 'mobx';
import { request, apis } from '@/utils/net';

const store = observable({
    info: {
        version: '',
        update_info: '',
        updated_at: 0
    },
    fetchUpdateInfo() {
        return request({
            url: apis.getUpdateInfo,
            unforeseen: () => {}
        })
        .then(data => {
            this.info = data || {}
            return data.version
        })
        // 获取当前最新版本信息后，需要调用 postVersionNotice 插入数据
        // 当返回的数据 data.notice_status = 0 时，标识当前用户没提示过，即弹窗提示版本更新说明
        .then(version => {
            return request({
                url: apis.postVersionNotice,
                data: { version, app_id: 'pc' },
                method: 'POST',
                unforeseen: () => {},
            })
        })
    }
})

export default store;
